import { ListPageSkeleton } from '@practium/ui';
import type { ListPageSkeletonProps } from '@practium/ui';

export const UsersPageSkeleton = ({ tabsCount = 1 }: Pick<ListPageSkeletonProps, 'tabsCount'>) => (
	<ListPageSkeleton
		tabsCount={tabsCount}
		sidebarWidth="27rem"
		sidebarW1500="22rem"
		sidebarW1300="19rem"
		sidebarW1200="17rem"
	/>
);
